import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useCreateBranch } from "hooks/useBranches"; // Assuming you have a hook for creating branches
import { BaseButton } from "Components";

const AddBranchModal = ({ isOpen, toggle }) => {
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const { mutate: createBranch, isPending } = useCreateBranch();

  const handleSubmit = () => {
    const payload = { name, address };
    createBranch(payload, {
      onSuccess: () => {
        toggle(); // Close modal after successful creation
        resetForm();
      },
    });
  };

  const resetForm = () => {
    setName("");
    setAddress("");
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Add New Branch</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="branchName">Branch Name</Label>
          <Input
            id="branchName"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter branch name"
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="branchAddress">Branch Address</Label>
          <Input
            id="branchAddress"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder="Enter branch address"
            required
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <BaseButton
          color="primary"
          onClick={handleSubmit}
          loading={isPending}
          disabled={isPending}
        >
          Add Branch
        </BaseButton>
        <BaseButton color="secondary" onClick={toggle}>
          Cancel
        </BaseButton>
      </ModalFooter>
    </Modal>
  );
};

export default AddBranchModal;
